import { g as getNumberFormat } from './formatNumber-_rBNDjjP-B-cxWpqK.js';

/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} currency Currency formatting.
 * Possible values are the ISO 4217 currency codes, such as "USD" for the US dollar, "EUR" for the euro.
 * @param {string} minimumFractionDigits The minimum number of fraction digits to use.
 * @param {string} maximumFractionDigits The maximum number of fraction digits to use.
 * The default is the larger of minimumFractionDigits and the
 * number of minor unit digits provided by the ISO 4217 currency code list.
 */
const formatCurrency = getNumberFormat(({
  currency,
  minimumFractionDigits,
  maximumFractionDigits
}) => ({
  style: 'currency',
  currencyDisplay: 'symbol',
  signDisplay: 'auto',
  currency,
  minimumFractionDigits,
  maximumFractionDigits
}));

export { formatCurrency as f };
//# sourceMappingURL=formatCurrency-CF25MK_2-Dz8ReRun.js.map
